import * as React from 'react';
import { getInitialBody } from '../data-entry/News/daily-news.utils';
import { BlogEditorReadOnlyWithStyles } from '@doltech/ui/lib/figma/BlogEditor/BlogEditorReadOnlyWithStylesPlugin';
import { useBlogEditorReadOnlyPlugin } from '@doltech/ui/lib/figma/BlogEditor/hooks/useBlogEditorReadOnlyPlugin';
import {
  VocabListNewsReadOnlyPlugin
} from '@doltech/ui/lib/figma/BlogEditor/plugins/VocabListNews/VocabListNewsReadOnlyPlugin';
import cl from 'classnames';

export const DailyNewsBlogEditorReadOnly = ({
  detailData,
  isReadOnly = false,
  seoData,
  className = '',
}) => {
  const { plugins } =
    useBlogEditorReadOnlyPlugin({
      extraPlugins: [VocabListNewsReadOnlyPlugin()]
    });
  const initialValue = React.useMemo(() => {
    const body = getInitialBody(detailData);
    return typeof body?.content === 'string' ? JSON.parse(body?.content) : body?.content;
  }, [detailData]);

  return (
    <BlogEditorReadOnlyWithStyles
      className={cl(className, 'dol-editor')}
      pageData={detailData}
      seoData={seoData}
      isReadOnly
      initialValue={initialValue}
      plugins={plugins}
    />
  );
};
